import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TypeRegisterIndex } from './IRegisterIndex';
import DefaultLayout from '../../layouts/DefaultLayout';
import Container from '../../components/ui/Container';
import Breadcrumbs from '../../components/Breadcrumbs';
import { cn } from '../../helpers/utils';

const breadcrumbLinks = [
  { name: 'Home', linkTo: '/' },
  { name: 'Registers', linkTo: '/over/registers' },
];

export const RegisterIndexPage: React.FC<TypeRegisterIndex> = ({
  branche_en_keurmerkregisters,
  branche_en_specialistenregisters,
}) => {
  const [isTopOneOpen, setIsTopOneOpen] = useState(true);
  const [isBottomOneOpen, setIsBottomOneOpen] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    // This determines if clicked on "Beroeps- en specialistenregisters" link in the sitemap
    // and pre-opens the correct accordion on mobile.
    if (hash === '#beroeps-en-specialisten-registers') {
      setIsTopOneOpen(false);
      setIsBottomOneOpen(true);
    }
  }, []);

  return (
    <DefaultLayout breadcrumbs={<Breadcrumbs links={breadcrumbLinks} />}>
      <Container className="pb-16 md:pb-24">
        <h1 className="font-bold text-blue-500 font-avantgarde text-xl md:text-2xl mb-6">Registers</h1>
        <div className="flex flex-col md:flex-row md:gap-12">
          <div className="w-full border-b border-stone-200 md:border-0">
            <div className="flex justify-between items-center my-3">
              <h2 className="hidden md:block font-bold text-blue-700 font-avantgarde text-lg md:text-xl md:mb-6">
                Branche- en keurmerkregisters
              </h2>
              <button
                data-testid="button-1"
                type="button"
                onClick={() => setIsTopOneOpen((prev) => !prev)}
                className="group flex w-full justify-between items-center md:hidden transition-transform duration-300"
              >
                <h2 className="font-bold text-blue-700 group-hover:text-blue-800 font-avantgarde text-lg md:mb-6">
                  Branche- en keurmerkregisters
                </h2>
                <FontAwesomeIcon
                  className={cn(
                    'text-blue-500 group-hover:text-blue-700 font-black text-sm',
                    isTopOneOpen ? '' : 'rotate-[180deg]',
                  )}
                  icon={faAngleUp as IconProp}
                />
              </button>
            </div>
            <ul
              className={`w-full ${isTopOneOpen ? 'block' : 'hidden md:block'}`}
              role="list"
            >
            {branche_en_keurmerkregisters?.map(({ name, slug }) => (
                <li
                  key={slug}
                  className="w-full py-3 lg:py-6 border-b border-b-stone-200 last:border-b-0"
                >
                  <a
                    className="no-underline font-bold"
                    href={`/over/register/${slug}`}
                  >
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="w-full">
            <div className="flex justify-between items-center my-3">
              <h2 className="hidden md:block font-bold text-blue-700 font-avantgarde text-lg md:text-xl md:mb-6">
                Beroeps- en specialistenregisters
              </h2>
              <button
                type="button"
                data-testid="button-2"
                onClick={() => setIsBottomOneOpen((prev) => !prev)}
                className="group flex w-full justify-between items-center md:hidden transition-transform duration-300"
              >
                <h2 className="font-bold text-blue-700 group-hover:text-blue-800 font-avantgarde text-lg md:mb-6">
                  Beroeps- en specialistenregisters
                </h2>
                <FontAwesomeIcon
                  className={cn(
                    'text-blue-500 group-hover:text-blue-700 font-black text-sm',
                    isBottomOneOpen ? '' : 'rotate-[180deg]',
                  )}
                  icon={faAngleUp as IconProp}
                />
              </button>
            </div>
            <ul
              className={`w-full ${isBottomOneOpen ? 'block' : 'hidden md:block'}`}
              role="list"
            >
            {branche_en_specialistenregisters?.map(
                ({ name, slug }) => (
                  <li
                    key={slug}
                    className="w-full py-3 lg:py-6 border-b border-b-stone-200 last:border-b-0"
                  >
                    <a
                      className="no-underline font-bold"
                      href={`${origin}/over/register/${slug}`}
                    >
                      {name}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </Container>
    </DefaultLayout>
  );
};
